import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import CommentItem, { commentItemShape } from './CommentItem';
import { TITLE_COMMENT, TITLE_COMMENT_EN } from '../../../utils/common/constant';
import { SettingConsumer } from '../../../contexts/settingContext';
import { asyncDownVoteComment, asyncNeutralVoteComment, asyncUpVoteComment } from '../../../middleware/comment/action';
import { CommentForumList, SpanCommentLength } from '../../styled';

const CommentList = ({ comments, commentLength }) => {
  const dispatch = useDispatch();

  const downVoteComment = ({ id }) => {
    dispatch(asyncDownVoteComment(id));
  };

  const neutralVoteComment = ({ id }) => {
    dispatch(asyncNeutralVoteComment(id));
  };

  const upVoteComment = ({ id }) => {
    dispatch(asyncUpVoteComment(id));
  };

  return (
    <SettingConsumer>
      {
        ({ locale }) => (
          <CommentForumList className="forum-list">
            <SpanCommentLength>
              {locale === 'id' ? TITLE_COMMENT : TITLE_COMMENT_EN}
              {' '}
              (
              {commentLength}
              )
            </SpanCommentLength>
            {
              comments.map((comment) => (
                <CommentItem
                  key={comment.id}
                  {...comment}
                  downVoteComment={downVoteComment}
                  neutralVoteComment={neutralVoteComment}
                  upVoteComment={upVoteComment}
                />
              ))
            }
          </CommentForumList>
        )
      }
    </SettingConsumer>
  );
};

CommentList.propTypes = {
  comments: PropTypes.arrayOf(PropTypes.shape(commentItemShape)).isRequired,
  commentLength: PropTypes.string.isRequired,
};

export default CommentList;
